import { Coffee } from 'lucide-react';

export function ComeBackLater() {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center p-8 text-center animate-in fade-in zoom-in duration-500">
      <div className="rounded-full bg-brand-surface p-6 ring-1 ring-brand-border mb-6 shadow-xl">
        <Coffee className="h-12 w-12 text-brand-orange" />
      </div>
      <div className="text-xs font-bold uppercase tracking-widest text-brand-text-secondary">
        Annotation Queue
      </div>
      <div className="mt-3 text-4xl font-bold text-white tracking-tight">All caught up</div>
      <div className="mt-2 text-lg text-brand-text-secondary max-w-md mx-auto">
        No episodes are ready for annotation right now. Check back later!
      </div>
    </div>
  );
}
